import react from "react";
import "./style.less"
import 'rc-texty/assets/index.css';
import QueueAnim from 'rc-queue-anim';
import {Col, Row} from "antd";

export default class Content0 extends react.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="datalink-content0">
                <QueueAnim delay={300} className="videos">
                    <Row key="row">
                        <Col span={"12"}>
                            <div key="a" className={"video-item item1"}>
                                <div className="item-title">
                                    自动追踪天线
                                </div>
                                <div className="item-text" style={{bottom: 22}}>
                                    <p>
                                        自动跟踪定向天线在工作时，始终面向飞行器的方向，以保证最佳的通信信号强度。<br></br>适合远距离通信，50km 及以上控制距离可选。</p>
                                </div>
                            </div>
                        </Col>
                        <Col span={"12"}>
                            <div key="b" className={"video-item item2"}>
                                <div className="item-title">全向定向一体天线</div>
                                <div className="item-text">
                                    <p>
                                        全定一体天线工作时，全向天线会在360度方向上收发信号， 同时结合定向平板进行传输，<br></br>系统会自动选择任意一个时间点信号最强的通道进行传输，地面定向天线需要手动进行方向调整，<br></br>适用于30km及以下的通信范围。
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </QueueAnim>
            </div>
        )
    }
}
